import { Trans, useTranslation } from 'react-i18next'
import { TourWelcomeModal, Button, Icon, IconTypes, IconColor } from '@app/ui'
import { ButtonType } from '@app/types'
import styled, { css } from 'styled-components'

interface WelcomeModalProps {
  open: boolean
  username: string
  tourWelcomePoints: Array<{ msg: string; icon: string }>
  welcomeIcon: string | JSX.Element
  onNext: () => void
}

export const WelcomeModal = ({
  open,
  username,
  tourWelcomePoints,
  welcomeIcon,
  onNext
}: WelcomeModalProps) => {
  const { t } = useTranslation()

  return (
    <TourWelcomeModal
      title={t('tipstertour.step.welcome', { name: username })}
      sub={t('tipstertour.step.welcome.sub')}
      open={open}
      zIndex={11}
      icon={welcomeIcon}
      styleExtender={WelcomeContentStyles}
    >
      <>
        <div className="title-wrapper">
          <p className="title">{t('tipstertour.step.tittle')}: </p>
        </div>
        <div className="bodyWrapper">
          {tourWelcomePoints.map(({ msg, icon }, key) => (
            <div className="body" key={key}>
              <span className="icon">{icon}</span>
              <p className="caption"><Trans i18nKey={msg} /></p>
            </div>
          ))}
        </div>
        <p className="cta">{t('tipstertour.step.cta')}</p>
        <StartButton
          className="vb-font w500 small white"
          type={ButtonType.primary}
          onClick={onNext}
        >
          <p className="icon-text">
            {t('tipstertour.step.start')}
          </p>
          <span className="icon">
            <Icon
              type={IconTypes.arrowRight}
              color={IconColor.white}
              width={16}
              height={16}
            />
          </span>
        </StartButton>
        <a href="/legal" className="tnc">
          <Trans i18nKey={'tipstertour.step.agree'} />
        </a>
      </>
    </TourWelcomeModal>
  )
}

const StartButton = styled(Button)`
  border-radius: 59px;
`

const WelcomeContentStyles = css`
  .content .tnc {
    color: #92979F;
    font-size: 11px;
    font-weight: 400;
    margin-top: 12px;
    width: 100%;
    text-align: center;
    margin-bottom: 12px;
    a {
      text-decoration: underline;
    }
  }
  .content a.tnc {
    text-decoration: none;
  }
  .content .cta {
    color: #48C0AE;
    text-align: center;
    font-size: 16px;
    font-weight: 700;
    width: 100%;
    margin: 24px 0;
  }
  .content button {
    display: inline-block;
    width: 100%;
    .icon, .icon-text {
      display: inline-block;
      padding: 0 2.5px;
      vertical-align: middle;
      color: #FFF;
      font-size: 14px;
      font-weight: 500;
    }
    .icon {
      position: relative;
      transform: translateY(2px);
    }
  }
  .bodyWrapper {
    max-width: 100vw;
    max-height: 100dvh;
    margin: auto;
  }
  .content .body {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-top: 16px;
  }
  .body .caption {
    color: #2B2D30;
    font-size: 14px;
    font-weight: 500;
  }
  .body .icon {
    transform: translateY(2px);
  }
  .title-wrapper {
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
  }
  .content .title {
    color: #2B2D30;
    text-align: center;
    font-size: 18px;
    font-weight: 700;
    margin-bottom: 8px;
    width: 100%;
  }
  .body .caption span:first-of-type {
    color: #2B2D30;
    font-size: 14px;
    font-weight: 700;
  }
`